import React from "react";
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

const NumberFormatDollars = React.forwardRef(function NumberFormatDollars(props, ref) {
  const { inputRef, onChange, ...numberFormatProps } = props;

  return (
    <NumericFormat
      {...numberFormatProps}
      getInputRef={ref || inputRef}
      allowNegative={false}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      prefix="$"
      isAllowed={({ value }) => {
        if (value !== "" && props?.maxvalue) {
          const regex = /^\d+(\.\d{0,2})?$/;

          if (!regex.test(value)) {
            return false;
          }

          const enteredValue = Number(value.replace(/,/g, ""));

          if (enteredValue > props.maxvalue) {
            return false;
          }

          // Reject any decimal part when value equals max
          if (enteredValue === props.maxvalue && value.includes(".")) {
            return false;
          }

          return true;
        }

        return true;
      }}
    />
  );
});

NumberFormatDollars.propTypes = {
  inputRef: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default NumberFormatDollars;
